import { Subscription } from 'rxjs/Subscription';
import { MultiAgencyService } from './../../../shared/multi-agency/multi-agency.service';
import { OnInit, Component } from '@angular/core';
import { MenuStore } from '../../../menus/service/menu.store';
import { CompletedUnpaidDashboardStore } from '../../service/completed-unpaid-dashboard.store';
import { MissingAgencyDashboardStore } from '../../service/missing-agency-dashboard.store';
import { UserLocalStorageService } from '../../../permission/services/user.local.storage.service';
import { DashboardFilterState } from './dashboard-filter';
import { AuthenticationStore } from '../../../permission/services/authentication.store';
import { User } from '../../../auth/models/User';
import { MultiAgency } from 'app/shared/models/multi-agency';
import { Observable } from 'rxjs/Observable';
import { EventStore } from 'app/event/service/event.store';
import { OnDestroy } from '@angular/core';

@Component({
  selector: 'pioneer-dashboard',
  templateUrl: './dashboard.component.html'
})
export class DashboardComponent implements OnInit, OnDestroy {

  showCompletedAndUnpaid: boolean;
  showMissingAgency: boolean;
  user: User;

  defaultAgency$: Observable<MultiAgency> = this.multiAgencyService.defaultAgency$;
  agencySubscription$: Subscription = new Subscription();

  constructor(
    private menuStore: MenuStore,
    private completedUnpaidDashboardStore: CompletedUnpaidDashboardStore,
    private missingAgencyDashboardStore: MissingAgencyDashboardStore,
    private userLocalStorageService: UserLocalStorageService,
    private authenticationStore: AuthenticationStore,
    private multiAgencyService: MultiAgencyService,
    private eventStore: EventStore
  ) {}

  ngOnInit(): void {
    this.menuStore.setPageHeader('DASHBOARD.TITLE', false);

    this.eventStore.resetSelectedEvent();

    this.showCompletedAndUnpaid = true;
    this.showMissingAgency = true;

    this.agencySubscription$ = this.defaultAgency$.subscribe(() => {
      this.completedUnpaidDashboardStore.loadTotals().subscribe();
      this.missingAgencyDashboardStore.loadTotals().subscribe();
    });

    this.authenticationStore.user.subscribe((user: User) => {
      this.user = user;
    });

    this.completedUnpaidDashboardStore.showCard().subscribe(bool => {
      this.showCompletedAndUnpaid = bool;
    });

    this.missingAgencyDashboardStore.showCard().subscribe(bool => {
      this.showMissingAgency = bool;
    });

  }

  toggleShowCompletedAndUnpaid(): void {
    this.showCompletedAndUnpaid = !this.showCompletedAndUnpaid;
    this.saveDashboardStateToLocalStorage();
  }

  toggleShowMissingAgency(): void {
    this.showMissingAgency = !this.showMissingAgency;
    this.saveDashboardStateToLocalStorage();
  }

  private saveDashboardStateToLocalStorage() {
    const dashboardFilters = new DashboardFilterState({
      completedAndUnpaid: this.showCompletedAndUnpaid,
      missingAgency: this.showMissingAgency
    });
    const email = this.user.email;
    this.userLocalStorageService.setDashboardFilterState(email, dashboardFilters);
  }

  ngOnDestroy() {
    this.agencySubscription$.unsubscribe();
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/dashboard/dashboard-page/dashboard.component.ts